import React, { Component, createContext } from "react";
import { auth, firestore } from "../firebase";

export const UserContext = createContext({
  loaded: false,
  user: null,
});

class UserProvider extends Component {
  state = {
    loaded: false,
    user: null,
  };

  componentDidMount = async () => {
    auth.onAuthStateChanged(async user => {
      if(user) {
        this.setState({
          loaded: true,
          user: user,
        });
      } else {
        this.setState({
          loaded: true,
          user: null,
        });
      }
    });
  };

  render() {
    return (
      <UserContext.Provider value={this.state}>
        {this.props.children}
      </UserContext.Provider>
    );
  }
}
export default UserProvider;